// extracted by mini-css-extract-plugin
export default {"contents":"AuthStyle_contents__jEi9j","left":"AuthStyle_left__AT9X0","right":"AuthStyle_right__Ve9dZ","input":"AuthStyle_input__XkqTK"};